<div class="page-container">
    <ng-container header>
        <div class="header-container">
            <div class="header-title-with-toggle">
                <ham-page-header
                    [title]="'aumico_organization_settings_mandate_management_configuration_page_header'"
                    [hasBackButton]="false"
                ></ham-page-header>
                <ham-toggle
                    [formControlValue]="isMandateAndTaskManagementEnabled"
                    hamTooltip="{{
                'aumico_organization_settings_mandate_management_configuration_mandate_and_tasks_toggle_tooltip' | i18next
                }}"
                >
                </ham-toggle>
            </div>

            <div class="header-actions">
                <!-- REV-22155: which template is shown and saved -->
                <ham-segmented-toggle
                    data-testid="configuration-subject-toggle"
                    [options]="subjectToggleOptions"
                    [selected]="subjectType$ | async"
                    (selectionChange)="onSubjectToggle($event)"
                ></ham-segmented-toggle>
                <span class="ham-icon" (click)="showInfoDialog = true">
                    <i class="info-outline-icon"></i>
                </span>
            </div>
        </div>
    </ng-container>

    <ng-container content>
        <div class="content-container">
            <!-- REV-22155: the person template only once it exists (mandate management active) -->
            <workflow-configurator
                *ngIf="(subjectType$ | async) === 'COMPANY' || savedWorkflow"
                [area]="'MANDATE_MANAGEMENT'"
                [workflowDto]="savedWorkflow"
                (onEditSection)="updateSection($event)"
                (onWorkflowFormChange)="onWorkflowFormValueChange($event)"
            ></workflow-configurator>
        </div>
    </ng-container>

    <ng-template #footerTemplate>
        <aum-action-bar-pure nextButtonText="{{'aumico_button_save' | i18next}}" [nextButtonAction]="nextButtonAction">
        </aum-action-bar-pure>
    </ng-template>
</div>
<ham-modal
    *ngIf="showInfoDialog"
    [saveText]="'aumico_notes_info_dialog_column_done' | i18next"
    (cancel)="showInfoDialog = false"
    (save)="showInfoDialog = false"
    [size]="'sm'"
    [title]="'aumico_organization_settings_mandate_management_configuration_info_title' | i18next"
>
    <span [innerHTML]=" 'aumico_organization_settings_mandate_management_configuration_info_text1' | i18next"></span>
    <br /><br />
    <span [innerHTML]=" 'aumico_organization_settings_mandate_management_configuration_info_text2' | i18next"></span>
    <br /><br />
    <span
        style="white-space: pre-line"
        [innerHTML]=" 'aumico_organization_settings_mandate_management_configuration_info_text_example' | i18next"
    ></span>
</ham-modal>
